import "../_config/packs/vue_app";
import { registerServiceWorker } from "../_config/packs/register_service_workers";

registerServiceWorker();
